import { render } from "./PreviewVehicleFiles.vue?vue&type=template&id=b3a5fe28"
import script from "./PreviewVehicleFiles.vue?vue&type=script&lang=js"
export * from "./PreviewVehicleFiles.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__